import _ from 'lodash';
import chartColors from '../../../shared/js/lib/chartColors';
import DashboardNavigation from '../components/DashboardNavigation';
import React, { PropTypes } from 'react';
import { Doughnut } from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';
import { getDoughnutChartData, getDoughnutChartOptions } from '../lib/dashboardCharts';
import { propertyHasChanged } from '../../../a2i/js/lib/objectComparison';

let DashboardStudentOverview = React.createClass({
	propTypes: {
		observation: PropTypes.object.isRequired,
		router: PropTypes.object.isRequired
	},

	getInitialState: function() {
		return {
			students: null
		};
	},

	componentWillMount: function() {
		this.setStudentsInState(this.props.observation);
	},

	componentWillReceiveProps: function(newProps) {
		if (propertyHasChanged(this.props.observation, newProps.observation)) {
			this.setStudentsInState(newProps.observation);
		}
	},

	setStudentsInState: function(observation) {
		let students = [],
			studentIds = [];

		this.props.observation.student_observations.map((studentObservation) => {
			if (!studentIds.includes(studentObservation.student_id)) {
				studentIds.push(studentObservation.student_id);

				if (studentObservation.student) {
					students.push(studentObservation.student);
				}
			}
		});

		this.setState({ students: _.sortBy(students, ['first_name', 'last_name']) });
	},

	getStudentObservations: function(studentId) {
		return this.props.observation.student_observations.filter((studentObservation) => {
			return studentObservation.student_id === studentId;
		});
	},

	render: function() {
		return (
			<div className="observation-overview">
				<div className="row observation-dashboard-header">
					<div className="col-md-8">
						<h2>
							Student Overview
						</h2>
					</div>
					<div className="col-md-4">
						<DashboardNavigation observation={ this.props.observation } router={ this.props.router } />
					</div>
				</div>

				<div className="row">
					{
						this.state.students.map((student, index) => {
							return (
								<div
									className={ 'col-md-' + Math.round(12 / this.state.students.length) }
									key={ 'student-overview-' + student.id + '-' + index }
								>
									<div
										className="dashboard-card chart-card link-card"
										onClick={ () => this.props.router.push('/dashboard/' + this.props.observation.id + '/students/' + student.id) }
									>
										<h3>{ student.first_name + ' ' + student.last_name }</h3>
										<p>Minutes Observed</p>
										<div className="chart-container">
											<Doughnut
												data={ getDoughnutChartData(this.getStudentObservations(student.id), 'observation_subject') }
												options={ getDoughnutChartOptions() }
											/>
										</div>
									</div>
								</div>
							);
						})
					}
				</div>
			</div>
		);
	}
});

module.exports = DashboardStudentOverview;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/DashboardStudentOverview.jsx